export const getFontWeight = ({ theme, fontWeight })=>{
    switch(fontWeight){
        case 'regular':
            {
                return theme.typography.fontWeightRegular;
            }
        case 'medium':
            {
                return theme.typography.fontWeightMedium;
            }
        case 'semi-bold':
            {
                return theme.typography.fontWeightSemiBold;
            }
        default:
            {
                return theme.typography.fontWeightRegular;
            }
    }
};
export const getVisuallyHiddenStyles = ()=>{
    return {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: '1px',
        margin: '-1px',
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        width: '1px'
    };
};

//# sourceMappingURL=typography.utils.js.map